import { reduce, concat } from 'ramda';

import AllReportsThumb from 'assets/icons/ReportThumbs/all_reports.png';

import { PerformanceReportsMock } from './scenes/ReportDetail/scenes/PerformanceReports';
import { CustomReportsMock } from './scenes/ReportDetail/scenes/CustomReports';

type ReportRules = {
  whitelistReports: string[];
};

const concatAll = reduce(concat as any, []);

const allReports = [
  {
    key: 'allReports',
    text: 'All Reports',
    value: 'allReports',
    image: AllReportsThumb,
    meta: { thirdPartyReport: false, showForOnline: true },
  },
];

const data = {
  reports: concatAll([allReports, PerformanceReportsMock, CustomReportsMock]),
};

const reportsTargetingRules = (merchantName: string) => {
  const whitelistMerchants: string[] = [
    `Sam's Club`,
    'Costco',
    `BJ's Wholesale Club`,
    'Dosh Depot',
    'Walmart.com',
    'Walmart Grocery',
  ];

  if (whitelistMerchants.includes(merchantName)) {
    return true;
  }

  return false;
};

const reportsConfig: { [index: string]: ReportRules } = {
  [`Sam's Club`]: {
    whitelistReports: ['merchantMembershipsMetrics', 'merchantRevenueMetrics'],
  },
  ['Costco']: {
    whitelistReports: [
      'merchantMembershipsMetrics',
      'merchantRevenueMetrics',
      'costcoMembershipExperimentMetrics',
    ],
  },
  [`BJ's Wholesale Club`]: {
    whitelistReports: ['merchantMembershipsMetrics'],
  },
  ['Walmart.com']: {
    whitelistReports: [
      'aggregateMerchantMembershipsMetrics',
      'merchantRevenueMetrics',
    ],
  },
  ['Walmart Grocery']: {
    whitelistReports: ['aggregateMerchantMembershipsMetrics'],
  },
  ['AT&T']: {
    whitelistReports: ['attMetricsBySegment'],
  },
};

export { ReportRules, reportsTargetingRules, reportsConfig };
export default data;
